import {
  AddCouponCode,
  AddCourse,
  AddItem,
  AddItemsToStore,
  AddSection,
  AddStore,
  AddVideo,
  AddVideoChunk,
  AdminGetCourseDetails,
  AdminGetCourses,
  ChangeSalePrice,
  ChangeUserPassword,
  DeleteImgFromItem,
  DeleteItem,
  DeleteSalePrice,
  DeleteVideo,
  EditCouponCode,
  EditItem,
  EditStore,
  EditVideo,
  GetActiveCouponCodes,
  GetBoughtItems,
  GetItems,
  GetStores,
  GetUsers,
  GetUsersCsv,
  GiveUserFreeCourse,
  RelaseCourse,
  SendEmails,
  ServerRoutes,
  UpdateCourseOriginalPrice,
  UpdateItemsStatus,
  UpdateSection
} from "@rinastyling/common";
import { createFormData } from "../utils/createFormData";
import { ServerService } from "./ServerService";
export class AdminService extends ServerService {
  constructor() {
    super(ServerRoutes.admin);
  }
  addCourse(body: AddCourse["request"]) {
    return this.typedFetch<AddCourse["request"], AddCourse["response"]>(
      "add-course",
      { body, method: "POST" }
    );
  }
  updateCourseOriginalPrice(body: UpdateCourseOriginalPrice["request"]) {
    return this.typedFetch<
      UpdateCourseOriginalPrice["request"],
      UpdateCourseOriginalPrice["response"]
    >("update-course-original-price", { body, method: "PUT" });
  }
  addSection(body: AddSection["request"]) {
    return this.typedFetch<AddSection["request"], AddSection["response"]>(
      "add-section",
      { body, method: "POST" }
    );
  }
  addVideo(
    body: Omit<AddVideo["request"], "video" | "attachment">,
    files: { attachment: File | null }
  ) {
    const data = this.fileFormDataBuilder({ ...body, ...files });

    return this.typedFetch<FormData, AddVideo["response"]>("add-video", {
      body: data,
      method: "POST"
      //
    });
  }
  addVideoChunk(body: AddVideoChunk["request"]) {
    const data = this.fileFormDataBuilder({ ...body });

    return this.typedFetch<FormData, AddVideoChunk["response"]>(
      "add-video-chunk",
      {
        body: data,
        method: "POST"
      }
    );
  }
  editVideo(body: EditVideo["request"]) {
    const formData = this.fileFormDataBuilder(body);

    return this.typedFetch<FormData, EditVideo["response"]>("edit-video", {
      body: formData,
      method: "PUT"
    });
  }
  getCourses() {
    return this.typedFetch<
      AdminGetCourses["request"],
      AdminGetCourses["response"]
    >("courses");
  }
  getCourseDetails(params: AdminGetCourseDetails["params"]) {
    return this.typedFetch<
      AdminGetCourseDetails["request"],
      AdminGetCourseDetails["response"]
    >("course/" + params.id);
  }
  uploadCourse(params: RelaseCourse["params"]) {
    return this.typedFetch<RelaseCourse["request"], RelaseCourse["response"]>(
      "release-course/" + params.courseId,
      { method: "PUT" }
    );
  }
  updateCourseSalePrice(params: ChangeSalePrice["params"]) {
    return this.typedFetch<
      ChangeSalePrice["request"],
      ChangeSalePrice["response"]
    >("change-sale-price/" + params.courseId + "/" + params.salePrice, {
      method: "PUT"
    });
  }
  deleteCourseSalePrice(params: DeleteSalePrice["params"]) {
    return this.typedFetch<
      DeleteSalePrice["request"],
      DeleteSalePrice["response"]
    >("delete-sale-price/" + params.courseId, { method: "DELETE" });
  }
  getUsersCsv() {
    return this.typedFetch<GetUsersCsv["request"], GetUsersCsv["response"]>(
      "users-csv",
      { method: "GET" }
    );
  }

  deleteVideo(params: DeleteVideo["params"]) {
    return this.typedFetch<DeleteVideo["request"], DeleteVideo["response"]>(
      "video/" + params.videoId,
      { method: "DELETE" }
    );
  }
  addCouponCode(body: AddCouponCode["request"]) {
    return this.typedFetch<AddCouponCode["request"], AddCouponCode["response"]>(
      "add-coupon-code",
      { body, method: "POST" }
    );
  }
  editCouponCode(body: EditCouponCode["request"]) {
    return this.typedFetch<
      EditCouponCode["request"],
      EditCouponCode["response"]
    >("edit-coupon-code", { body, method: "PUT" });
  }
  getActiveCouponCodes() {
    return this.typedFetch<
      GetActiveCouponCodes["request"],
      GetActiveCouponCodes["response"]
    >("coupon-codes");
  }
  updateSection(body: UpdateSection["request"]) {
    return this.typedFetch<UpdateSection["request"], UpdateSection["response"]>(
      "update-section",
      { body, method: "PUT" }
    );
  }
  addStore(body: Omit<AddStore["request"], "img"> & { img: File }) {
    const { name, startDate, img } = body;
    const formData = createFormData({
      obj: { name, startDate },
      files: { fieldName: "img", files: img }
    });
    return this.typedFetch<FormData, AddStore["response"]>("add-store", {
      body: formData,
      method: "POST"
    });
  }
  editStore(body: EditStore["request"], params: EditStore["params"]) {
    const formData = this.fileFormDataBuilder(body);
    return this.typedFetch<FormData, EditStore["response"]>(
      `edit-store/${params.storeId}`,
      {
        body: formData,
        method: "PUT"
      }
    );
  }
  getStores() {
    return this.typedFetch<GetStores["request"], GetStores["response"]>(
      "get-stores"
    );
  }
  addItem(body: Omit<AddItem["request"], "imgs"> & { imgs: FileList }) {
    const { description, imgs, name, price, popupStoreId } = body;
    const formData = createFormData({
      obj: { description, name, price, popupStoreId },
      files: { fieldName: "imgs", files: imgs }
    });
    return this.typedFetch<FormData, AddItem["response"]>("add-item", {
      body: formData,
      method: "POST"
    });
  }
  deleteItem(params: DeleteItem["params"]) {
    return this.typedFetch<DeleteItem["request"], DeleteItem["response"]>(
      `delete-item/${params.itemId}`,
      { method: "DELETE" }
    );
  }

  editItem(
    body: Omit<EditItem["request"], "imgs"> & { imgs: FileList | null }
  ) {
    const { description, imgs, name, price, popupStoreId, id, status } = body;
    const formData = createFormData({
      obj: { description, name, price, popupStoreId, id, status },
      files: imgs ? { fieldName: "imgs", files: imgs } : undefined
    });
    return this.typedFetch<FormData, EditItem["response"]>("edit-item", {
      body: formData,
      method: "PUT"
    });
  }
  deleteImgFromItem(query: DeleteImgFromItem["query"]) {
    return this.typedFetch<
      DeleteImgFromItem["request"],
      DeleteImgFromItem["response"]
    >("delete-img-from-item", { method: "DELETE" }, query);
  }

  getItems() {
    return this.typedFetch<GetItems["request"], GetItems["response"]>(
      "get-items"
    );
  }

  addItemsToStore(body: AddItemsToStore["request"]) {
    return this.typedFetch<
      AddItemsToStore["request"],
      AddItemsToStore["response"]
    >("add-items-to-store", { body, method: "PUT" });
  }
  getUsers() {
    return this.typedFetch<GetUsers["request"], GetUsers["response"]>(
      "get-users"
    );
  }
  giveUserFreeCourse(body: GiveUserFreeCourse["request"]) {
    return this.typedFetch<
      GiveUserFreeCourse["request"],
      GiveUserFreeCourse["response"]
    >("give-user-free-course", { body, method: "PUT" });
  }

  getBoughtItems(params: GetBoughtItems["params"]) {
    return this.typedFetch<
      GetBoughtItems["request"],
      GetBoughtItems["response"]
    >("get-bought-items/" + params.storeId);
  }
  updateItemsStatus(body: UpdateItemsStatus["request"]) {
    return this.typedFetch<
      UpdateItemsStatus["request"],
      UpdateItemsStatus["response"]
    >("update-items-statuses", { body, method: "PUT" });
  }

  sendEmails(body: SendEmails["request"]) {
    return this.typedFetch<SendEmails["request"], SendEmails["response"]>(
      "send-emails",
      { body, method: "POST" }
    );
  }
  changeUserPassword(body: ChangeUserPassword["request"]) {
    return this.typedFetch<
      ChangeUserPassword["request"],
      ChangeUserPassword["response"]
    >("change-user-password", { body, method: "POST" });
  }
}
